// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"64fc9481","977":"373d618c"}[chunkId] + ".chunk.js";
};